import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IOption } from 'ng-select';
import { GeneralService } from '../../../shared/services/general.service';
import { HelperService } from '../../../shared/services/helper.service';
import { AlertService } from '../../../shared/services/alert.service';
import { ExportService } from '../../../core/services/export/export.service';
import { ReportService } from '../../../core/services/report/report.service';
import { AuthService } from '../../../core/services/auth/auth.service';

@Component({
  selector: 'app-report-thirdparty-info',
  templateUrl: './report-thirdparty-info.component.html',
  styleUrls: ['./report-thirdparty-info.component.scss'],
  providers: [ReportService, ExportService]
})
export class ReportThirdpartyInfoComponent implements OnInit {

  @ViewChild('datatable') dtElements;

  public frmReportThirdparty: FormGroup;

  //List
  public ledgerList: Array<IOption> = [];
  public yearList: Array<IOption> = [];
  public formatList: Array<IOption> = [];
  public conceptList: Array<IOption> = [];

  //Table
  public rowsOnPage: number;
  public sortBy: string;
  public sortOrder: string;
  public filterQuery: string;
  public filterBy: string;
  public mfData: any[];
  public user: any;

  constructor(
    private _formBuilder: FormBuilder,
    private _generalService: GeneralService,
    private _helperService: HelperService,
    private _alertService: AlertService,
    private _conceptsRangeService: ReportService,
    private _exportService: ExportService,
    private _authService: AuthService
  ) {
    this.buildValidations();
    this.runReportRequest();
    this.initDataTable();
  }

  ngOnInit() {
    this._authService.getSession().then(
      (user) => {
        this.user = user;
      }
    ).catch((e) => {
      this._alertService.openSwal({ title: 'Error', text: 'Expiro la sessión', type: 'error' });
    });
  }

  buildValidations(): void {
    this.frmReportThirdparty = this._formBuilder.group({
      p_ledger_id: [null, [Validators.required]],
      p_year: [null],
    });
  }

  private initDataTable(): void {
    this.rowsOnPage = 5;
    this.sortBy = '';
    this.sortOrder = '';
    this.filterQuery = '';
    this.filterBy = 'source';
    this.mfData = [];
  }

  get getColumns() {
    return [
      { id: "source", name: "Origen" },
      { id: "party_id", name: "Party Id" },
      { id: "party_name", name: "Party  Name" },
      { id: "party_numeric", name: "Party Numric" },
      { id: "third_numeric", name: "Third Numeric" },
      { id: "nit", name: "Nit" },
      { id: "third_name", name: "Nombre Tercero" },
      { id: "first_name", name: "Primer Nombre" },
      { id: "second_name", name: "Segundo Nombre" },
      { id: "last_name1", name: "Primer Apellido" },
      { id: "last_name2", name: "Segundo Apellido" },
      { id: "country_code", name: "Pais" },
      { id: "city_code", name: "Ciudad" },
      { id: "address", name: "Direccion" },
      { id: "email", name: "Email" },
      { id: "phone_numeric", name: "Telefono" },
      { id: "cell_phone", name: "Celular" },
      { id: "primary_address", name: "Direccion Primaria" },
      { id: "document_type", name: "Tipo De Documento" },
      { id: "economic_activity", name: "Actividad Economica" },
      { id: "nature", name: "Naturaleza" },
      { id: "third_status", name: "Estado Tercero Cloud" },
      { id: "verifying_digit", name: "Digito Verificacion" },
      { id: "status", name: "Estado Colokial" },
      { id: "third_mv", name: "Tiene Movimiento" },
      { id: "reported_nit", name: "Nit Reportado" },
      { id: "error", name: "Error" },
      { id: "alert", name: "Alerta" },
      { id: "val_info_add", name: "Validacion Inf. Terceros" },
    ];
  }

  onSubmit() {
    if (!this.frmReportThirdparty.validate()) return;

    this.mfData = [];

    this._conceptsRangeService.repThirdparty(this.frmReportThirdparty.value, {
      success: res => {

        this.mfData = res.data;
      },
      error: err => {
        console.log("repFormatConcepts error -> ", err);
        this._alertService.openSwal({
          text: err.message,
          type: 'error'
        });
      },
      always: () => { },
      includeToken: false
    });
  }

  getYears(event: any) {


    this.frmReportThirdparty.patchValue({
      p_year: null,
    });

    this._conceptsRangeService.getThirdpartyYears(event.value, {
      success: res => {

        if (res.status == 0) {
          this.yearList = res.data.map((item) => {
            return {
              value: item.period_year,
              label: item.period_year
            };
          });
        }
      },
      error: err => {
        console.log("getYears error -> ", err);
        this._alertService.openSwal({
          text: err.message,
          type: 'error'
        });
      },
      always: () => { },
      includeToken: false
    });
  }


  runReportRequest() {
    this._generalService.getLedger().then(
      (books) => {
        this.ledgerList = this._helperService.createSelect(books);
      }
    );
  }

  exportExcel() {
    const nameFile = 'reporte_informacion_terceros';
    const tittle = 'Reporte Información Terceros';
    const columns_name = this.getColumns.map( item  => item.name );
    let  columns_id = this.getColumns.map(item => item.id);

    const data = this.mfData.map((row: any) => {
      const rowData =[];

      columns_id.forEach(
        col_name => {
          rowData.push(row[col_name])
        }
      );

      return rowData;
    });

    const params = [
      { name: 'Parametros', value: '' },
      { name: 'Libro', value: this.ledgerList.find(a => a.value == this.frmReportThirdparty.value.p_ledger_id).label },
      { name: 'Año', value: this.frmReportThirdparty.value.p_year },
    ];

    this._generalService.generic_excel_report(data, 
                                              nameFile, 
                                              this._exportService.urlLogo,
                                              tittle,
                                              params, 
                                              columns_name )
  }

  exportFileCsv() {
    const nameFile = 'reporte_informacion_terceros';

    const data = this.mfData.map((row) => {
      const rowData = {};
      for (let index = 0; index < this.getColumns.length; index++) {
        rowData[this.getColumns[index].name] = row[this.getColumns[index].id];
      }
      return rowData;
    });
    
    this._exportService.exportToFile(data, nameFile, '.csv', "text/csv;chasret=utf-8", ';');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/magnetic-media/report-thirdparty-info/report-thirdparty-info.component.ts